<div class="self-sign-complete">
  @if (isError) {
    <kzn-status-message [message]="errorMessage"></kzn-status-message>
  } @else {
    <div class="self-sign-complete__shell">
      <div class="self-sign-complete__preview-card">
        <div class="self-sign-complete__preview-toolbar">
          <div class="self-sign-complete__toolbar-group">
            <button
              type="button"
              mat-icon-button
              class="self-sign-complete__toolbar-btn"
              [disabled]="currentPage <= 1 || isRendering || showPreviewLoader"
              (click)="goToPreviousPage()">
              <mat-icon>chevron_left</mat-icon>
            </button>
            <span class="self-sign-complete__toolbar-label">{{ currentPage }} / {{ totalPages || 1 }}</span>
            <button
              type="button"
              mat-icon-button
              class="self-sign-complete__toolbar-btn"
              [disabled]="currentPage >= totalPages || isRendering || showPreviewLoader"
              (click)="goToNextPage()">
              <mat-icon>chevron_right</mat-icon>
            </button>
          </div>

          <div class="self-sign-complete__toolbar-divider" aria-hidden="true"></div>

          <div class="self-sign-complete__toolbar-group">
            <button
              type="button"
              mat-icon-button
              class="self-sign-complete__toolbar-btn"
              [disabled]="zoomPercent <= 50 || isRendering || showPreviewLoader"
              (click)="zoomOut()">
              <mat-icon>remove</mat-icon>
            </button>
            <span class="self-sign-complete__toolbar-label">{{ zoomPercent }}%</span>
            <button
              type="button"
              mat-icon-button
              class="self-sign-complete__toolbar-btn"
              [disabled]="zoomPercent >= 200 || isRendering || showPreviewLoader"
              (click)="zoomIn()">
              <mat-icon>add</mat-icon>
            </button>
          </div>
        </div>

        <div class="self-sign-complete__preview-body" #pdfViewport (scroll)="onPreviewScroll()">
          @if (showPreviewLoader) {
            <div class="self-sign-complete__preview-loading">
              <kzn-loader [message]="'selfSignCompleteLoading' | translate"></kzn-loader>
            </div>
          }
          <div class="self-sign-complete__pages" #pdfPagesHost></div>
        </div>
      </div>

      <div class="self-sign-complete__side-panel">
        <div class="self-sign-complete__header">
          <img
            src="assets/doc-signed1.png"
            alt=""
            class="self-sign-complete__success-image" />
          <h2 class="self-sign-complete__title">{{ 'selfSignCompleteTitle' | translate }}</h2>
          @if (docName) {
            <p class="self-sign-complete__doc-name">{{ docName }}</p>
          }
        </div>

        <div class="self-sign-complete__actions">
          <button
            mat-flat-button
            type="button"
            color="primary"
            class="self-sign-complete__btn-download"
            [disabled]="!hasPdf"
            (click)="downloadPdf()">
            <mat-icon>download</mat-icon>
            {{ 'selfSignDownloadPdf' | translate }}
          </button>
        </div>
      </div>
    </div>
  }
</div>
